import { c as _c } from "react/compiler-runtime";
import { FileUploaderDropZone, fileInputAcceptTypes } from '@systemeio/file-manager';
import { FormSelect } from '@systemeio/ui';
import { useCampaignsList } from 'modules/campaigns/hooks/use-campaigns-list';
import { CampaignId } from 'modules/campaigns/types/campaign-interface';
import ContactSelectTags from 'modules/contacts/contact-page/components/contact-select-tags';
import LastContactsImportsTable from 'modules/contacts/contacts-import/components/last-contacts-imports-table';
import { SelectColumnsForContactsImportModal } from 'modules/contacts/contacts-import/components/select-columns-for-contacts-import-modal';
import { ContactsImportPageLoco } from 'modules/contacts/contacts-import/constants/contacts-import-page-loco';
import { ContactsImportDelimiter, getContactsImportDelimiterSelectOptions } from 'modules/contacts/contacts-import/types/contacts-import-delimeter-type';
import { ContactsLastImportsApiInterface } from 'modules/contacts/contacts-import/types/contacts-import-interface';
import { ContactBulkApiInterface } from 'modules/contacts/types/contact-menu-interface';
import { CreateNewTagModal } from 'modules/tags/components/create-new-tag-modal';
import { NextPage } from 'next';
import { useMemo, useRef, useState } from 'react';
import { InfoBlockOrderedListItem } from 'shared/components/info-block-ordered-list-item';
import { RequestModuleEnum } from 'shared/enums/request-module-enum';
import { useLocoTranslation } from 'shared/hooks/use-loco-translation';
import { useRevalidateModules } from 'shared/hooks/use-revalidate-modules';
import { getBaseServerSideProps } from 'shared/utils/get-base-server-side-props';
import { KeyedMutator } from 'swr';
import { CheckCircleIcon, InfoIcon, QuestionMarkIcon } from '@systemeio/ui/icons';
import { ContactImportWarning } from 'modules/contacts/contacts-import/components/contact-import-warning';
const ContactEdit: NextPage = () => {
  const $ = _c(183);
  const {
    t
  } = useLocoTranslation();
  const lastContactsImportsTableRef = useRef(null);
  const mutateLastContactsImportsTable = useRef(null);
  const [file, setFile] = useState(null);
  const [delimiter, setDelimiter] = useState(ContactsImportDelimiter.comma);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = [];
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const [selectedTags, setSelectedTags] = useState(t0);
  const [selectedCampaignId, setSelectedCampaignId] = useState();
  const {
    campaignsList
  } = useCampaignsList();
  const {
    revalidateModules
  } = useRevalidateModules();
  let t1;
  if ($[1] !== campaignsList?.items) {
    t1 = campaignsList?.items.map(_temp);
    $[1] = campaignsList?.items;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const campaignsListOptions = t1;
  let t2;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = () => {
      setSelectedCampaignId(undefined);
      setSelectedTags([]);
      setDelimiter(ContactsImportDelimiter.comma);
      setFile(null);
    };
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const clearStates = t2;
  let t3;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = mutate => {
      mutateLastContactsImportsTable.current = mutate;
    };
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  const setMutateLastContactsImports = t3;
  let t4;
  if ($[5] !== t) {
    t4 = getContactsImportDelimiterSelectOptions(t);
    $[5] = t;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  const contactsImportDelimiterSelectOptions = t4;
  let t5;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <ContactImportWarning />;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <QuestionMarkIcon className="fill-brand-primary mr-2 inline h-[20px] w-[20px]" />;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  let t7;
  if ($[9] !== t) {
    t7 = t("dashboard.contact_import.instruction.title-2");
    $[9] = t;
    $[10] = t7;
  } else {
    t7 = $[10];
  }
  let t8;
  if ($[11] !== t7) {
    t8 = <h3 className="mb-4 text-[18px] leading-6">{t6}{t7}</h3>;
    $[11] = t7;
    $[12] = t8;
  } else {
    t8 = $[12];
  }
  let t9;
  if ($[13] !== t) {
    t9 = t("dashboard.contact_import.instruction.first");
    $[13] = t;
    $[14] = t9;
  } else {
    t9 = $[14];
  }
  let t10;
  if ($[15] !== t9) {
    t10 = <InfoBlockOrderedListItem dangerouslySetInnerHTML={{
      __html: t9
    }} />;
    $[15] = t9;
    $[16] = t10;
  } else {
    t10 = $[16];
  }
  let t11;
  if ($[17] !== t) {
    t11 = t("dashboard.contact_import.instruction.second");
    $[17] = t;
    $[18] = t11;
  } else {
    t11 = $[18];
  }
  let t12;
  if ($[19] !== t11) {
    t12 = <InfoBlockOrderedListItem dangerouslySetInnerHTML={{
      __html: t11
    }} />;
    $[19] = t11;
    $[20] = t12;
  } else {
    t12 = $[20];
  }
  let t13;
  if ($[21] !== t) {
    t13 = t("dashboard.contact_import.instruction.third");
    $[21] = t;
    $[22] = t13;
  } else {
    t13 = $[22];
  }
  let t14;
  if ($[23] !== t13) {
    t14 = <InfoBlockOrderedListItem dangerouslySetInnerHTML={{
      __html: t13
    }} />;
    $[23] = t13;
    $[24] = t14;
  } else {
    t14 = $[24];
  }
  let t15;
  if ($[25] !== t) {
    t15 = t("dashboard.contact_import.instruction.fourth");
    $[25] = t;
    $[26] = t15;
  } else {
    t15 = $[26];
  }
  let t16;
  if ($[27] !== t15) {
    t16 = <InfoBlockOrderedListItem dangerouslySetInnerHTML={{
      __html: t15
    }} />;
    $[27] = t15;
    $[28] = t16;
  } else {
    t16 = $[28];
  }
  let t17;
  if ($[29] !== t) {
    t17 = t("dashboard.contact_import.instruction.fifth");
    $[29] = t;
    $[30] = t17;
  } else {
    t17 = $[30];
  }
  let t18;
  if ($[31] !== t17) {
    t18 = <InfoBlockOrderedListItem dangerouslySetInnerHTML={{
      __html: t17
    }} />;
    $[31] = t17;
    $[32] = t18;
  } else {
    t18 = $[32];
  }
  let t19;
  if ($[33] !== t) {
    t19 = t("dashboard.contact_import.instruction.subparagraph_first");
    $[33] = t;
    $[34] = t19;
  } else {
    t19 = $[34];
  }
  let t20;
  if ($[35] !== t19) {
    t20 = <li className="mb-2">{t19}</li>;
    $[35] = t19;
    $[36] = t20;
  } else {
    t20 = $[36];
  }
  let t21;
  if ($[37] !== t) {
    t21 = t("dashboard.contact_import.instruction.subparagraph_second");
    $[37] = t;
    $[38] = t21;
  } else {
    t21 = $[38];
  }
  let t22;
  if ($[39] !== t21) {
    t22 = <li>{t21}</li>;
    $[39] = t21;
    $[40] = t22;
  } else {
    t22 = $[40];
  }
  let t23;
  if ($[41] !== t20 || $[42] !== t22) {
    t23 = <ul className="list-disc pl-14">{t20}{t22}</ul>;
    $[41] = t20;
    $[42] = t22;
    $[43] = t23;
  } else {
    t23 = $[43];
  }
  let t24;
  if ($[44] !== t) {
    t24 = t("dashboard.contact_import.instruction.sixth");
    $[44] = t;
    $[45] = t24;
  } else {
    t24 = $[45];
  }
  let t25;
  if ($[46] !== t24) {
    t25 = <InfoBlockOrderedListItem dangerouslySetInnerHTML={{
      __html: t24
    }} />;
    $[46] = t24;
    $[47] = t25;
  } else {
    t25 = $[47];
  }
  let t26;
  if ($[48] !== t10 || $[49] !== t12 || $[50] !== t14 || $[51] !== t16 || $[52] !== t18 || $[53] !== t23 || $[54] !== t25) {
    t26 = <ul className="flex flex-col gap-6">{t10}{t12}{t14}{t16}{t18}{t23}{t25}</ul>;
    $[48] = t10;
    $[49] = t12;
    $[50] = t14;
    $[51] = t16;
    $[52] = t18;
    $[53] = t23;
    $[54] = t25;
    $[55] = t26;
  } else {
    t26 = $[55];
  }
  let t27;
  if ($[56] !== t) {
    t27 = t("dashboard.contact_import.instruction_popup.title");
    $[56] = t;
    $[57] = t27;
  } else {
    t27 = $[57];
  }
  let t28;
  if ($[58] !== t27) {
    t28 = <span className="text-text-primary text-[16px] font-bold leading-6">{t27}</span>;
    $[58] = t27;
    $[59] = t28;
  } else {
    t28 = $[59];
  }
  let t29;
  if ($[60] !== t) {
    t29 = t("dashboard.contact_import.instruction_popup.first");
    $[60] = t;
    $[61] = t29;
  } else {
    t29 = $[61];
  }
  let t30;
  if ($[62] !== t29) {
    t30 = <InfoBlockOrderedListItem dangerouslySetInnerHTML={{
      __html: t29
    }} />;
    $[62] = t29;
    $[63] = t30;
  } else {
    t30 = $[63];
  }
  let t31;
  if ($[64] !== t) {
    t31 = t("dashboard.contact_import.instruction_popup.second");
    $[64] = t;
    $[65] = t31;
  } else {
    t31 = $[65];
  }
  let t32;
  if ($[66] !== t31) {
    t32 = <InfoBlockOrderedListItem dangerouslySetInnerHTML={{
      __html: t31
    }} />;
    $[66] = t31;
    $[67] = t32;
  } else {
    t32 = $[67];
  }
  let t33;
  if ($[68] !== t) {
    t33 = t("dashboard.contact_import.instruction_popup.third-2");
    $[68] = t;
    $[69] = t33;
  } else {
    t33 = $[69];
  }
  let t34;
  if ($[70] !== t33) {
    t34 = <InfoBlockOrderedListItem dangerouslySetInnerHTML={{
      __html: t33
    }} />;
    $[70] = t33;
    $[71] = t34;
  } else {
    t34 = $[71];
  }
  let t35;
  if ($[72] !== t30 || $[73] !== t32 || $[74] !== t34) {
    t35 = <ul className="flex flex-col gap-6">{t30}{t32}{t34}</ul>;
    $[72] = t30;
    $[73] = t32;
    $[74] = t34;
    $[75] = t35;
  } else {
    t35 = $[75];
  }
  let t36;
  if ($[76] !== t26 || $[77] !== t28 || $[78] !== t35 || $[79] !== t8) {
    t36 = <div className={"bg-background-secondary flex h-fit flex-col gap-6\n        rounded-md p-6\n        xl:col-start-2 xl:row-start-1 xl:row-end-7"}>{t8}{t26}{t28}{t35}</div>;
    $[76] = t26;
    $[77] = t28;
    $[78] = t35;
    $[79] = t8;
    $[80] = t36;
  } else {
    t36 = $[80];
  }
  let t37;
  if ($[81] !== t) {
    t37 = t("dashboard.contact_import.import_file_block.title");
    $[81] = t;
    $[82] = t37;
  } else {
    t37 = $[82];
  }
  let t38;
  if ($[83] !== file) {
    t38 = file && <CheckCircleIcon className="fill-green h-[20px] w-[20px]" />;
    $[83] = file;
    $[84] = t38;
  } else {
    t38 = $[84];
  }
  let t39;
  if ($[85] !== t37 || $[86] !== t38) {
    t39 = <h1 className="mb-6 flex gap-2 self-start text-[17px] lg:self-center">{t37}{t38}</h1>;
    $[85] = t37;
    $[86] = t38;
    $[87] = t39;
  } else {
    t39 = $[87];
  }
  let t40;
  if ($[88] !== t) {
    t40 = t("dashboard.contact_import.form.label.delimiter");
    $[88] = t;
    $[89] = t40;
  } else {
    t40 = $[89];
  }
  let t41;
  if ($[90] === Symbol.for("react.memo_cache_sentinel")) {
    t41 = data => data && setDelimiter(data);
    $[90] = t41;
  } else {
    t41 = $[90];
  }
  let t42;
  if ($[91] !== contactsImportDelimiterSelectOptions || $[92] !== delimiter || $[93] !== t40) {
    t42 = <div className="flex grow basis-[300px] flex-col gap-9"><FormSelect withoutCloseIcon={true} label={t40} data={contactsImportDelimiterSelectOptions} value={delimiter} onChange={t41} /></div>;
    $[91] = contactsImportDelimiterSelectOptions;
    $[92] = delimiter;
    $[93] = t40;
    $[94] = t42;
  } else {
    t42 = $[94];
  }
  let t43;
  if ($[95] !== file || $[96] !== t) {
    t43 = <>{file ? <p>{file.name}</p> : <p>{t("dashboard.contact_import.form.label.import-file.title")}</p>}</>;
    $[95] = file;
    $[96] = t;
    $[97] = t43;
  } else {
    t43 = $[97];
  }
  let t44;
  if ($[98] !== t) {
    t44 = t("dashboard.contact_import.form.toast.file_upload_complete");
    $[98] = t;
    $[99] = t44;
  } else {
    t44 = $[99];
  }
  let t45;
  if ($[100] !== t43 || $[101] !== t44) {
    t45 = <FileUploaderDropZone acceptTypes={fileInputAcceptTypes.csv} className="grow basis-40 md:shrink-0" dropZoneClassName="h-full" onSelectFile={setFile} label={t43} toastText={t44} />;
    $[100] = t43;
    $[101] = t44;
    $[102] = t45;
  } else {
    t45 = $[102];
  }
  let t46;
  if ($[103] === Symbol.for("react.memo_cache_sentinel")) {
    t46 = <InfoIcon className="fill-brand-primary mr-2 inline" />;
    $[103] = t46;
  } else {
    t46 = $[103];
  }
  let t47;
  if ($[104] !== t) {
    t47 = t("dashboard.contact_import.form.label.import-file.info");
    $[104] = t;
    $[105] = t47;
  } else {
    t47 = $[105];
  }
  let t48;
  if ($[106] !== t47) {
    t48 = <p className="flex items-center">{t46}{t47}</p>;
    $[106] = t47;
    $[107] = t48;
  } else {
    t48 = $[107];
  }
  let t49;
  if ($[108] !== t45 || $[109] !== t48) {
    t49 = <div className="flex flex-col gap-3.5">{t45}{t48}</div>;
    $[108] = t45;
    $[109] = t48;
    $[110] = t49;
  } else {
    t49 = $[110];
  }
  let t50;
  if ($[111] !== t42 || $[112] !== t49) {
    t50 = <div className="flex flex-wrap gap-7">{t42}{t49}</div>;
    $[111] = t42;
    $[112] = t49;
    $[113] = t50;
  } else {
    t50 = $[113];
  }
  let t51;
  if ($[114] !== t39 || $[115] !== t50) {
    t51 = <div className="bg-background-secondary rounded-md p-6">{t39}{t50}</div>;
    $[114] = t39;
    $[115] = t50;
    $[116] = t51;
  } else {
    t51 = $[116];
  }
  let t52;
  if ($[117] === Symbol.for("react.memo_cache_sentinel")) {
    t52 = () => setSelectedTags([]);
    $[117] = t52;
  } else {
    t52 = $[117];
  }
  let t53;
  if ($[118] !== revalidateModules) {
    t53 = <CreateNewTagModal onCreate={async () => {
      await revalidateModules([RequestModuleEnum.Tags]);
    }} />;
    $[118] = revalidateModules;
    $[119] = t53;
  } else {
    t53 = $[119];
  }
  let t54;
  if ($[120] !== selectedTags || $[121] !== t53) {
    t54 = <ContactSelectTags className="bg-background-secondary rounded-lg p-6 xl:col-start-1" tempTags={selectedTags} setTempTags={setSelectedTags} resetTags={t52} additionalButtonBarComponent={t53} />;
    $[120] = selectedTags;
    $[121] = t53;
    $[122] = t54;
  } else {
    t54 = $[122];
  }
  let t55;
  if ($[123] !== t) {
    t55 = t("dashboard.contact_import.campaign_title");
    $[123] = t;
    $[124] = t55;
  } else {
    t55 = $[124];
  }
  let t56;
  if ($[125] !== t55) {
    t56 = <h1 className="mb-2 self-start text-[17px] lg:self-center">{t55}</h1>;
    $[125] = t55;
    $[126] = t56;
  } else {
    t56 = $[126];
  }
  let t57;
  if ($[127] !== t) {
    t57 = t("dashboard.contact_import.form.label.campaign");
    $[127] = t;
    $[128] = t57;
  } else {
    t57 = $[128];
  }
  let t58;
  if ($[129] !== t57) {
    t58 = <span>{t57}</span>;
    $[129] = t57;
    $[130] = t58;
  } else {
    t58 = $[130];
  }
  let t59;
  if ($[131] !== t56 || $[132] !== t58) {
    t59 = <div className="mb-6">{t56}{t58}</div>;
    $[131] = t56;
    $[132] = t58;
    $[133] = t59;
  } else {
    t59 = $[133];
  }
  const t60 = !campaignsList;
  let t61;
  if ($[134] !== campaignsListOptions || $[135] !== selectedCampaignId || $[136] !== t60) {
    t61 = <div className="flex flex-wrap gap-7"><div className="flex grow basis-[300px] flex-col gap-9"><FormSelect isPreFetching={t60} data={campaignsListOptions} value={selectedCampaignId} onChange={setSelectedCampaignId} /></div></div>;
    $[134] = campaignsListOptions;
    $[135] = selectedCampaignId;
    $[136] = t60;
    $[137] = t61;
  } else {
    t61 = $[137];
  }
  let t62;
  if ($[138] !== t59 || $[139] !== t61) {
    t62 = <div className="flex flex-1 flex-col">{t59}{t61}</div>;
    $[138] = t59;
    $[139] = t61;
    $[140] = t62;
  } else {
    t62 = $[140];
  }
  let t63;
  if ($[141] === Symbol.for("react.memo_cache_sentinel")) {
    t63 = <QuestionMarkIcon className="fill-brand-primary inline h-[16px] w-[16px]" />;
    $[141] = t63;
  } else {
    t63 = $[141];
  }
  let t64;
  if ($[142] !== t) {
    t64 = t("dashboard.contact_import.campaign_instruction.title");
    $[142] = t;
    $[143] = t64;
  } else {
    t64 = $[143];
  }
  let t65;
  if ($[144] !== t64) {
    t65 = <div className="mb-10 flex items-center gap-3">{t63}<span className="text-text-primary text-base font-bold">{t64}</span></div>;
    $[144] = t64;
    $[145] = t65;
  } else {
    t65 = $[145];
  }
  let t66;
  if ($[146] !== t) {
    t66 = t("dashboard.contact_import.campaign_instruction.first");
    $[146] = t;
    $[147] = t66;
  } else {
    t66 = $[147];
  }
  let t67;
  if ($[148] !== t66) {
    t67 = <span dangerouslySetInnerHTML={{
      __html: t66
    }} />;
    $[148] = t66;
    $[149] = t67;
  } else {
    t67 = $[149];
  }
  let t68;
  if ($[150] !== t) {
    t68 = t("dashboard.contact_import.campaign_instruction.second");
    $[150] = t;
    $[151] = t68;
  } else {
    t68 = $[151];
  }
  let t69;
  if ($[152] !== t68) {
    t69 = <li className="mb-2">{t68}</li>;
    $[152] = t68;
    $[153] = t69;
  } else {
    t69 = $[153];
  }
  let t70;
  if ($[154] !== t) {
    t70 = t("dashboard.contact_import.campaign_instruction.third");
    $[154] = t;
    $[155] = t70;
  } else {
    t70 = $[155];
  }
  let t71;
  if ($[156] !== t70) {
    t71 = <li>{t70}</li>;
    $[156] = t70;
    $[157] = t71;
  } else {
    t71 = $[157];
  }
  let t72;
  if ($[158] !== t69 || $[159] !== t71) {
    t72 = <ul className="mt-3 list-disc pl-3.5">{t69}{t71}</ul>;
    $[158] = t69;
    $[159] = t71;
    $[160] = t72;
  } else {
    t72 = $[160];
  }
  let t73;
  if ($[161] !== t67 || $[162] !== t72) {
    t73 = <div>{t67}{t72}</div>;
    $[161] = t67;
    $[162] = t72;
    $[163] = t73;
  } else {
    t73 = $[163];
  }
  let t74;
  if ($[164] !== t65 || $[165] !== t73) {
    t74 = <div className="sm:max-w-[340px]"><div className="border-text-secondary/30 rounded-lg border p-6">{t65}{t73}</div></div>;
    $[164] = t65;
    $[165] = t73;
    $[166] = t74;
  } else {
    t74 = $[166];
  }
  let t75;
  if ($[167] !== t62 || $[168] !== t74) {
    t75 = <div className="bg-background-secondary flex flex-wrap gap-8 rounded-md p-6 lg:self-center">{t62}{t74}</div>;
    $[167] = t62;
    $[168] = t74;
    $[169] = t75;
  } else {
    t75 = $[169];
  }
  let t76;
  if ($[170] === Symbol.for("react.memo_cache_sentinel")) {
    t76 = async () => {
      mutateLastContactsImportsTable.current && (await mutateLastContactsImportsTable.current());
    };
    $[170] = t76;
  } else {
    t76 = $[170];
  }
  let t77;
  if ($[171] !== delimiter || $[172] !== file || $[173] !== selectedCampaignId || $[174] !== selectedTags) {
    t77 = <div className="flex justify-center"><SelectColumnsForContactsImportModal file={file} delimiter={delimiter} campaign={selectedCampaignId} tags={selectedTags} onConfirm={t76} clearStates={clearStates} /></div>;
    $[171] = delimiter;
    $[172] = file;
    $[173] = selectedCampaignId;
    $[174] = selectedTags;
    $[175] = t77;
  } else {
    t77 = $[175];
  }
  let t78;
  if ($[176] === Symbol.for("react.memo_cache_sentinel")) {
    t78 = <LastContactsImportsTable ref={lastContactsImportsTableRef} className="rounded-lg lg:col-start-1" setMutateLastContactsImports={setMutateLastContactsImports} />;
    $[176] = t78;
  } else {
    t78 = $[176];
  }
  let t79;
  if ($[177] !== t36 || $[178] !== t51 || $[179] !== t54 || $[180] !== t75 || $[181] !== t77) {
    t79 = <div className="grid gap-6 lg:gap-11 xl:grid-cols-[1fr_485px]">{t5}{t36}{t51}{t54}{t75}{t77}{t78}</div>;
    $[177] = t36;
    $[178] = t51;
    $[179] = t54;
    $[180] = t75;
    $[181] = t77;
    $[182] = t79;
  } else {
    t79 = $[182];
  }
  return t79;
};
export const getServerSideProps = getBaseServerSideProps(ContactsImportPageLoco, 'header.top_menu.contacts');
export default ContactEdit;
function _temp(t0) {
  const {
    id,
    name
  } = t0;
  return {
    id,
    caption: name
  };
}